import { DrawingTool } from '@trimble/geospatial';

type LayerGeometryType = 'Point' | 'Line' | 'Area' | 'None';

function isLayerGeometryType(value: string): value is LayerGeometryType {
  return (
    value === 'Point' ||
    value === 'Line' ||
    value === 'Area' ||
    value === 'None'
  );
}

// PascalCase keys mirror the Maps API geometry-type strings;
/* eslint-disable @typescript-eslint/naming-convention */
const GEOMETRY_TO_DRAWING_TOOLS: Record<
  LayerGeometryType,
  readonly DrawingTool[]
> = {
  Point: [DrawingTool.Point],
  Line: [DrawingTool.CompoundCurve, DrawingTool.Rectangle],
  Area: [DrawingTool.Polygon, DrawingTool.Rectangle],
  None: [],
};
/* eslint-enable @typescript-eslint/naming-convention */

export function mapLayerGeometryToDrawingTools(
  geometryType: string | undefined
): readonly DrawingTool[] {
  if (geometryType === undefined || !isLayerGeometryType(geometryType)) {
    return [];
  }
  return GEOMETRY_TO_DRAWING_TOOLS[geometryType];
}
